module.exports = __webpack_public_path__ + "static/media/search-test-your-search.e422e160.png";